import { Building2, BriefcaseBusiness, ClipboardCheck, ClipboardList, ContactRound, Factory, FileText, Package, PackagePlus, ScanBarcode, Send, Store, Truck, UserRound } from "lucide-react";

export type SearchType =
  | "lead" | "deal" | "account" | "contact"
  | "order" | "quote" | "dispatch" | "workorder" | "challan"
  | "product" | "roll" | "supplier" | "receipt" | "qc";

export interface SearchHit {
  type: SearchType;
  id: string;
  title: string;
  detail: string;
  href: string;
  /** Document number, barcode or code; typing it whole opens the record */
  code?: string;
}

export interface SearchGroup {
  type: SearchType;
  items: SearchHit[];
  page: number;
  page_size: number;
  has_more: boolean;
}

export interface SearchResponse {
  query: string;
  groups: SearchGroup[];
  failed_types?: SearchType[];
  jump?: SearchHit | null;
}

/** What each kind of result is called, who may search it, the list page that shows all of it, and its icon */
export const TYPE_INFO: Record<SearchType, { title: string; permission: string; href: string; icon: typeof UserRound }> = {
  lead: { title: "Leads", permission: "lead.read", href: "/leads", icon: UserRound },
  deal: { title: "Deals", permission: "deal.read", href: "/deals", icon: BriefcaseBusiness },
  account: { title: "Accounts", permission: "account.read", href: "/accounts", icon: Building2 },
  contact: { title: "Contacts", permission: "contact.read", href: "/contacts", icon: ContactRound },
  order: { title: "Orders", permission: "order.read", href: "/orders", icon: ClipboardList },
  quote: { title: "Quotes", permission: "quote.read", href: "/quotes", icon: FileText },
  dispatch: { title: "Dispatches", permission: "order.read", href: "/orders", icon: Truck },
  workorder: { title: "Work orders", permission: "production.read", href: "/production?tab=list", icon: Factory },
  challan: { title: "Job-work challans", permission: "production.read", href: "/production?tab=jobwork", icon: Send },
  product: { title: "Products", permission: "product.read", href: "/products", icon: Package },
  roll: { title: "Stock rolls", permission: "inventory.read", href: "/inventory?tab=rolls&filter=all", icon: ScanBarcode },
  supplier: { title: "Suppliers", permission: "inventory.read", href: "/suppliers", icon: Store },
  receipt: { title: "Goods receipts", permission: "inventory.read", href: "/inventory/receipts", icon: PackagePlus },
  qc: { title: "Inspections", permission: "inventory.read", href: "/inventory/quality", icon: ClipboardCheck },
};

/** The list page of a group, opened with the search text in its own search box */
export const listHref = (type: SearchType, query: string) => {
  const base = TYPE_INFO[type].href;
  return `${base}${base.includes("?") ? "&" : "?"}search=${encodeURIComponent(query)}`;
};
